import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../../api-slice';
import { ResponseGetUsersSchema } from './user.schema';

export const usersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createUser: builder.mutation({
            query: (data) => ({
                url: 'users',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [SLICE_TAG.USERS],
        }),

        getUsers: builder.query({
            query: (params) => {
                return {
                    url: 'users',
                    method: 'GET',
                    params,
                };
            },
            providesTags: [SLICE_TAG.USERS],
            keepUnusedDataFor: 600,

            transformResponse: (response) => {
                return ResponseGetUsersSchema.parse(response);
            },
        }),

        getUserById: builder.query({
            query: (userId) => {
                return {
                    url: `users/${userId}`,
                    method: 'GET',
                };
            },
            providesTags: [SLICE_TAG.USERS],
            keepUnusedDataFor: 600,

            // transformResponse: (response) => {
            //     return ResponseGetUsersSchema.parse(response);
            // },
        }),

        updateUserById: builder.mutation({
            query: ({ userId, data }) => ({
                url: `users/${userId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: [SLICE_TAG.USERS],
        }),

        deleteUserById: builder.mutation({
            query: (userId) => ({
                url: `users/${userId}`,
                method: 'DELETE',
            }),
            invalidatesTags: [SLICE_TAG.USERS],
        }),
    }),
});

export const {
    useGetUserByIdQuery,
    useLazyGetUserByIdQuery,
    useCreateUserMutation,
    useUpdateUserByIdMutation,
    useGetUsersQuery,
    useLazyGetUsersQuery,

    useDeleteUserByIdMutation,
} = usersApi;
